import CardPlayTrainer, { CARDPLAY_HAS_NEW, CARDPLAY_PUZZLES } from "../CardPlay/CardPlayTrainer";

export const DECLARER_PUZZLES = CARDPLAY_PUZZLES;
export const DECLARER_HAS_NEW = CARDPLAY_HAS_NEW;

export default CardPlayTrainer;
